import { Field } from 'react-final-form'
import { pushToDataLayer } from '../../../../gtm'
import styles from './CheckboxSelect.module.scss'

export default function CheckboxSelect({
  title,
  titleEn,
  sectionTitle,
  value,
  queryName,
}) {
  const handleChange = (value) => {
    if(value) {
      pushToDataLayer({
        event: 'interaction',
        eventCategory: 'Dive Shop',
        eventAction: 'Search - Filter',
        eventLabel: `${sectionTitle} - ${titleEn || title}`,
        eventValue: '0',
        eventNonInteraction: 'false',
      })
    }
  }
  return (
    <Field
      name={queryName || 'name'}
      component={Checkbox}
      type='checkbox'
      title={title}
      value={`${value}`}
      onChange={handleChange}
    />
  )
}

const Checkbox = ({ input, value, title, onChange }) => {
  const handleChange = (e) => {
    input.onChange(e)
    if(onChange) {
      onChange(e.target.checked)
    }
  }
  return (
    <label className={styles.checkboxWrap}>
      <input
        type='checkbox'
        className={styles.inputCheckbox}
        value={value}
        {...input}
        onChange={handleChange}
      />
      <span className={styles.checkMark} />
      <p className={styles.title}>{title}</p>
    </label>
  )
}
